// import cookie from '../../lib/cookie.js'
import '../assets/scss/hosting.scss'
import WebsitesAdd from "./pages/WebsitesAdd"
import WebsitesEdit from "./pages/WebsitesEdit"
import Spinner from 'vue-simple-spinner'
import Vue from "vue"
import './icons/Skull';

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)
export default {
	components: {
		WebsitesAdd,
		WebsitesEdit,
		Spinner
	},
	watch: {
		showStatus(a, b) {
			if (a !== b) {
				this.setStatusFilter();
			}
		},
		showProviders(a, b) {
			if (a !== b) {
				this.setCategoryFilter();
			}
		},
		perPage(a, b) {
			if (a !== b) {
				// this.clearSelected();
			}
		},
		currentPage(a, b) {
			if (a !== b) {
				// this.clearSelected();
			}
		},
		filter(a, b) {
			if (a !== b) {
				// this.clearSelected();
			}
		}
	},

	filters: {
		convertage: function (value) {
			let vv = parseInt(value)
			if (!value || value == null || value == 'null') return '--'
			else {
				if (vv > 72) {
					return Math.ceil(vv / 24).toString() + " D";
				}
				else {
					return vv.toString() + " H";
				}
			}
		}

	},

	data() {
		return {
			loading: false,
			checkedItems: [],
			tableValues: [],
			multichoice: '',
			sortBy: 'M_ID',
			fields: [
				{ key: 'M_ID', label: 'ID', sortable: true },
				{ key: 'M_DOMAIN', label: 'Domain', sortable: true },
				{ key: 'M_PROVIDER', label: 'Server', sortable: true },
				{ key: 'M_BASEIP', label: 'IP', sortable: true },
				{ key: 'M_UP', label: 'Uptime', sortable: true },
				{ key: 'M_INT_STATUS', label: 'Status', sortable: true },
				{ key: 'M_HASWP', label: 'WP', sortable: false },
				{ key: 'M_BACKUP_AGE', label: 'Backup', sortable: true },
				{ key: 'actions', label: 'Actions', 'class': 'text-right' },
			],
			currentPage: 1,
			displayType: null,
			pageOptions: [5, 10, 20, 50, 100],
			filter: null,
			attemptedReloadForFilter: false,
			lastFilterAttempted: null,
			modalInfo: { title: '', content: '' },
			showeditor: false,
			showadder: false,
			token: '',
			rows: [],
			hostings: [],
			registries: [],
			site: {},
			wpuser: '',
			wppwd: '',
			wpbaseurl: '',
			redirecturl: '',
			newsite: {},
			site_template: {
				'M_RID': 0, 'M_DOMAIN': '',
				'M_PROVIDER': '', 'M_BASEIP': '', 'M_FTP_USER': '',
				'M_FTP_PWD': '', 'M_WP_USER': '', 'M_WP_PWD': '',
				'M_WP_URL': '', 'M_SSH_USER': '', 'M_SSH_PWD': '',
				'M_PANEL_ADDRESS': '', 'M_PANEL_USER': '', 'M_PANEL_PWD': '',
				'M_OTHER': '', 'M_SHORTNOTE': '', 'M_INT_STATUS': ''
			},
			working: false,
			totalRows: 0,
			perPage: 20,

			limit: 5,
			currentPage: 1,
			providers: [],
			hasproviders: false,
			providerfields: [
				{ key: 'provider', label: 'Provider', sortable: true },
				{ key: 'amount', label: 'Amount', sortable: true },
				{ key: 'maxid', label: 'LastID', sortable: true },
			]
		};
	},

	created: function () {
		let that = this
		this.newsite = JSON.parse(JSON.stringify(this.site_template));
		this.loading = true;
		this.getServers()
		this.getDNS()
	},
	mounted: function () {
		console.log(this.type, "!!")
	},
	methods: {
		onFiltered(filteredItems) {
			// If there is an active filter, no results are found, and we haven't reloaded for this specific filter yet
			if (this.filter && filteredItems.length === 0) {
				if (!this.attemptedReloadForFilter || this.lastFilterAttempted !== this.filter) {
					this.attemptedReloadForFilter = true;
					this.lastFilterAttempted = this.filter;
					this.getServers();
					this.getDNS()
				}
			} else if (filteredItems.length > 0) {
				// Reset the flag when results are found, allowing future empty filters to trigger a reload
				this.attemptedReloadForFilter = false;
				this.lastFilterAttempted = null;
			}
		},

		getServers() {
			let that = this
			this.$http.get("/websites/list", { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') } })
				.then(resp => {
					if (resp.data.error) {
						alert("Connection failed: " + resp.data.error)
					}
					else {
						that.totalRows = parseInt(resp.data.length)
						that.rows = resp.data
						// that.hostings = JSON.parse(JSON.stringify(that.rows))
						let thostings = JSON.parse(JSON.stringify(that.rows))
						that.hostings = thostings.map(function (row) {
							if (parseInt(row.M_MONITOR_HTTP_STATUS) >= 300 || parseInt(row.M_MONITOR_HTTP_STATUS) == 0) {
								row['statusmsg'] = row.M_MONITOR_HTTP_STATUS + ' / ' + row.M_MONITOR_HTTP_LASTMSG
							}
							else {
								row['statusmsg'] = '200 / OK'
							}
							if (row.M_INT_STATUS == 3) row['int_statusmsg'] = 'READY'
							else if (row.M_INT_STATUS == 2) row['int_statusmsg'] = 'IN PROGRESS'
							else if (row.M_INT_STATUS == 1) row['int_statusmsg'] = 'PREPARED'
							else row['int_statusmsg'] = 'NOT READY'
							return row
						})
						that.totalPages = (that.total == 0) ? 0 : Math.ceil(that.total / that.perpage)
						// that.showInventoryChunk(start)
						this.loading = false;
					}
				})
				.catch(err => {
					// localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
					alert(err)
					this.loading = false;
				})
		},

		getDNS() {
			let that = this;
			this.$http.get("/base/dns", { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') } })
				.then(resp => {
					if (resp.data.error) {
						alert("Connection failed")
					}
					else {
						that.registries = resp.data
					}
				})
				.catch(err => {
					alert(err)
				})
		},

		closeTheEditor() {
			this.showeditor = false;
			this.showadder = false;
		},
		showAdd() {
			this.showadder = true;
		},
		showEditor() {
			this.showeditor = true;
		},
		resetModal() {
			this.modalInfo.title = ''
			this.modalInfo.content = ''
		},

		details(index, item) {
			this.site = this.findItemById(item.M_ID)
			this.showeditor = true;
		},


		updateSite(entry) {
			var that = this
			this.working = true;
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/websites/edit', entry, headers)
				.then(function (response) {
					that.working = false;
					that.showeditor = false;
					that.$toastr.Add({
						title: "Success", // Toast Title
						msg: "Update successful",
						position: "toast-top-center",
						type: "success"
					});
					that.getServers()
					console.log(response)
				})
				.catch(function (error) {
					that.working = false;
					alert("There was an error processing your request.")
					that.showeditor = false;
					console.log(error)
				})
			this.filter = "";

			// alert(this.filter + "!!")
		},



		insertSite(entry) {
			var that = this
			this.working = true;
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/websites/add', entry, headers)
				.then(function (response) {
					that.working = false;
					that.showadder = false;
					if (response['ID'] != '') entry['s_id'] = parseInt(response['ID'])
					that.hostings.unshift(entry)
					that.newsite = JSON.parse(JSON.stringify(that.site_template));
					console.log(that.newsite)
					that.$toastr.Add({
						title: "Success", // Toast Title
						msg: "Insert successful",
						position: "toast-top-center",
						type: "success"
					});
					that.getServers()
					console.log(response)
				})
				.catch(function (error) {
					that.working = false;
					alert("There was an error processing your request.")
					that.showadder = false;
					console.log(error)
				})
			// alert(entry.s_id + "!!")
		},

		deleteSite(sid) {
			var that = this
			console.log("deleting")
			let payload = { 'M_ID': sid }
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/websites/delete', payload, headers)
				.then(function (response) {
					console.log(response)
					for (var i = 0; i < that.hostings.length; i++) {
						if (that.hostings[i].M_ID == sid) {
							that.hostings.splice(i, 1)
						}
					}
					that.showeditor = false;
					that.$toastr.Add({
						title: "Success", // Toast Title
						msg: "Deletion successful",
						position: "toast-top-center",
						type: "success"
					});
				})
				.catch(function (error) {
					that.working = false;
					alert("There was an error processing your request.")
					that.showeditor = false;
					console.log(error)
				})
			// alert(sid + "!!")
		},

		killToggle(item) {
			let that = this
			console.log('kill  ', item)
			let active = 99
			if (item.M_ACTIVE == 1) {
				active = 2
			} else if (item.M_ACTIVE == 2) {
				active = 1
			}
			if (active != 99) {
				var headers = {
					headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
				}
				this.$http.post('/websites/setkill', { M_ID: item.M_ID, M_ACTIVE: active }, headers)
					.then(function () {
						for (let i = 0; i < that.hostings.length; i++) {
							if (that.hostings[i].M_ID === item.M_ID) {
								that.hostings[i].M_ACTIVE = active
								console.log("HUlla", item.M_ID)
								break
							}
						}
					})
					.catch(function (error) {
						alert("There was an error processing your request.\n" + error)
					})
			}
		},

		sendWpLogin(row) {
			// var id = this.getIndex(idx);
			// // let id = (idx + ((this.currentPage - 1) * this.perPage))
			// let row = this.hostings[id]
			// console.log(idx)
			// console.log(id)
			console.log(row)

			this.wpuser = row.item.M_WP_USER
			this.wppwd = row.item.M_WP_PWD
			this.redirecturl = row.item.M_WP_URL + "/wp-admin/"
			this.wpbaseurl = row.item.M_WP_URL + "/wp-login.php"
			this.$refs.wploginform.action = this.wpbaseurl;
			// this.$refs.wploginform.submit()
			var that = this
			window.setTimeout(that.subm, 500);

		},
		subm() {
			console.log("sub")
			this.$refs.wploginform.submit()
		},
		findItemById(sid) {
			for (var i = 0; i < this.hostings.length; i++) {
				if (this.hostings[i].M_ID == sid) {
					return this.hostings[i]
				}
			}
		},

		getProviders() {
			let that = this
			this.$http.get("/websites/providers", { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') } })
				.then(resp => {
					if (resp.data.error) {
						alert("Connection failed: " + resp.data.error)
					}
					else {
						that.providers = resp.data
						that.hasproviders = true
						this.loading = false;
					}
				})
				.catch(err => {
					// localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
					alert(err)
					this.loading = false;
				})
		}
	},


	mounted() {

	}
}
